import React, { useContext, useEffect, useReducer, useState } from 'react';
import fetchAPI from '../../../../utils/fetchAPI';
import useSkipUpdate from '../../../../hooks/useSkipRender';
import ChangeValueView from '../view/ChangeValueView';
import { FormContext } from '../../../form/FormContext';
import { AutomationsContex } from '../../../engine/FormBuilderAutomationsEngine';

const ChangeValueReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    case 'update_valueData':
      return { ...state, valueData: { ...state.valueData, ...payload } };

    default:
      return state;
  }
};

const initialReducerState = {
  valueData: { value: '', internalId: '' }
};

const SUBFIELDS_THAT_AUTOMATION_CAN_CHANGE = [
  'checktype',
  'firstName',
  'middleName',
  'surname',
  'email',
  'phone',
  'addressLine1',
  'addressLine2',
  'addressLine3',
  'addressLine4',
  'city',
  'county',
  'postcode',
  'country',
  'dateOfBirth',
  'loe',
  'title',
  'contactVia',
  'runAgain'
];

const isSubFieldThatAutomationCanChange = (field, allowedParentFields) => {
  const parentFieldId = field?.lookupInfo?.subFieldInfo?.parentFieldId;
  if (!parentFieldId) {
    return false;
  }
  const parentField = allowedParentFields.find(
    one => one.internalId === parentFieldId
  );
  if (!parentField) {
    return false;
  }
  if (
    SUBFIELDS_THAT_AUTOMATION_CAN_CHANGE.includes(
      field?.lookupInfo?.subFieldInfo?.externalFormFieldId
    )
  ) {
    return true;
  }
  return false;
};

const ChangeValueEngine = ({ update = d => d, variant, ...props }) => {
  const { formId } = props;
  const [data, dispatch] = useReducer(ChangeValueReducer, initialReducerState);
  const { shouldSkipUpdate, skipUpdate } = useSkipUpdate();
  const [formFields, setFormFields] = useState([]);
  const [field2Update, setField2Update] = useState('');

  useEffect(() => {
    if (shouldSkipUpdate()) {
      return;
    }
    update({ additionalParameters: { ...data } });
  }, [data]);

  useEffect(() => {
    if (formId) {
      fetchAPI(`/forms/v1/forms/${formId}`).then(response => {
        const allFields = [...response.adminFields, ...response.fields];
        const allowedParentFields = allFields.filter(
          one => one.uiType === 'credas'
        );
        const filteredFields = allFields.filter(
          f =>
            f.uiType !== 'file_upload' &&
            f.uiType !== 'instructional_text' &&
            f.uiType !== 'section_break' &&
            f.uiType !== 'score' &&
            (!f.lookupInfo ||
              isSubFieldThatAutomationCanChange(f, allowedParentFields) ||
              f.uiType === 'credas')
        );
        const allCredasParentFieldIds = allFields
          .filter(f => f.uiType === 'credas')
          .map(one => one.internalId);

        const valueData =
          props.additionalParameters && props.additionalParameters.valueData;
        if (valueData) {
          dispatch({
            type: 'update_valueData',
            payload: valueData
          });
        }
        setFormFields(filteredFields);
      });
    }
  }, [formId]);

  useEffect(() => {
    const field = formFields.find(
      f => f.internalId === data.valueData.internalId
    );
    if (field && Object.keys(field).length) {
      let copyOfField = { ...field };
      setField2Update({ ...copyOfField });
    }
  }, [data.valueData.internalId, formFields]);

  const setFieldValue = value => {
    dispatch({
      type: 'update_valueData',
      payload: { value }
    });
  };

  const setNumericValue = v => {
    dispatch({
      type: 'update_valueData',
      payload: { value: Number(v) }
    });
  };

  const setFieldId2Update = val => {
    dispatch({
      type: 'update_valueData',
      payload: { internalId: val, value: '' }
    });
  };

  const contextProps = {
    registerField: () => {},
    validateField: () => {}
  };

  const viewProps = {
    formFields,
    fieldId2Update: data.valueData.internalId,
    field2Update,
    setFieldId2Update,
    fieldValue: data.valueData.value,
    setNumericValue,
    setFieldValue,
    variant
  };

  return (
    <FormContext.Provider value={contextProps}>
      <ChangeValueView {...viewProps} />
    </FormContext.Provider>
  );
};

export default ChangeValueEngine;
